import { render, staticRenderFns } from "./SelectGame.vue?vue&type=template&id=07bdef66&"
import script from "./SelectGame.vue?vue&type=script&lang=ts&"
export * from "./SelectGame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SelectGame.vue"
export default component.exports